import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../models';

const sharedData: Pick<LocDef, 'feature' | 'htmlAllowed' | 'shared' | 'portal'> = {
	feature: HubFeature.Core,
	htmlAllowed: false,
	shared: true,
	portal: 'All',
};
const dpRoot = 'System|Global';

type SystemGlobalLocStart = 'CMSystemGlobal';
export type SystemGlobalLocs =
	| `${SystemGlobalLocStart}True`
	| `${SystemGlobalLocStart}False`
	| `${SystemGlobalLocStart}NA`
	| `${SystemGlobalLocStart}Download`
	| `${SystemGlobalLocStart}Never`
	| `${SystemGlobalLocStart}EmailPlaceholder`
	| `${SystemGlobalLocStart}Visit`
	| `${SystemGlobalLocStart}NoData`;

export const systemGlobalLocs: LocDefs<SystemGlobalLocs> = {
	CMSystemGlobalTrue: {
		...sharedData,
		defaultValue: 'Yes',
		displayPath: `${dpRoot}|True`,
		description: 'System value for true.',
		displayType: 'Content',
	},
	CMSystemGlobalFalse: {
		...sharedData,
		defaultValue: 'No',
		displayPath: `${dpRoot}|False`,
		description: 'System value for false.',
		displayType: 'Content',
	},
	CMSystemGlobalNA: {
		...sharedData,
		defaultValue: 'N/A',
		displayPath: `${dpRoot}|N/A`,
		description: 'System value for not available.',
		displayType: 'Content',
	},
	CMSystemGlobalDownload: {
		defaultValue: 'Download',
		displayPath: `${dpRoot}|Download`,
		description: 'System value for download.',
		displayType: 'Content',
		legacyName: 'Core/System.Global.Content.Download',
		portal: 'All',
	},
	CMSystemGlobalNever: {
		defaultValue: 'Never',
		displayPath: `${dpRoot}|Never`,
		description: 'System value for never.',
		displayType: 'Content',
		legacyName: 'Core/System.Global.Content.Never',
		portal: 'All',
	},
	CMSystemGlobalEmailPlaceholder: {
		...sharedData,
		defaultValue: 'example@example.com',
		displayPath: `${dpRoot}|Email Example`,
		description: 'Email address used as a placeholder example in email fields.',
		displayType: 'Content',
		legacyName: 'CandidateAccess/System.Global.Content.EmailPlaceholder',
	},
	CMSystemGlobalVisit: {
		...sharedData,
		defaultValue: 'Visit',
		displayPath: `${dpRoot}|Visit`,
		description: 'Visit text for links.',
		displayType: 'Content',
		legacyName: 'Core/System.Global.Content.Visit',
	},
	CMSystemGlobalNoData: {
		...sharedData,
		defaultValue: 'No Data',
		displayPath: `${dpRoot}|No Data`,
		description: 'Text shown when there is no data.',
		displayType: 'Content',
		legacyName: 'Core/System.Global.Content.NoData',
	},
};

export const GLOBAL_SYSTEM_LOCS = MapLocKeys<SystemGlobalLocs>(systemGlobalLocs);
export type GlobalSystemType = LocMap<SystemGlobalLocs>;
